
// STUDY_LEVELS
export const GET_STUDY_LEVELS = "/study-levels";
export const ADD_NEW_STUDY_LEVEL = "/study-levels";
export const UPDATE_STUDY_LEVEL = "/study-levels";
export const DELETE_STUDY_LEVEL = "/study-levels";


